var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8 30.65L33.2 19.25L31.1 17.2L21.95 26.35L16.9 21.3L14.7 23.5L21.8 30.65ZM24 43.95C19.3333 42.7833 15.5 40.075 12.5 35.825C9.5 31.575 8 26.9167 8 21.85V9.95L24 3.95L40 9.95V21.85C40 26.9167 38.5 31.575 35.5 35.825C32.5 40.075 28.6667 42.7833 24 43.95ZM24 40.85C27.8333 39.5833 30.9583 37.1917 33.375 33.675C35.7917 30.1583 37 26.2167 37 21.85V12.05L24 7.15L11 12.05V21.85C11 26.2167 12.2083 30.1583 14.625 33.675C17.0417 37.1917 20.1667 39.5833 24 40.85Z",
    fill: "#68627A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.357cf5b6c6a8cecb6867fbd01bf44d98.svg";
export { ForwardRef as ReactComponent };